module.exports = __webpack_public_path__ + "img/hamburger-ico.78522745.png";